import AbstractModel from '../AbstractModel';

class StandardEquipmentGroupModel extends AbstractModel {}

export default StandardEquipmentGroupModel;
